import {Description} from '../../../domain/Profile';

// TODO: update api-raw-types + use type here
export function toDescription(descriptionResource: any): Description {
    return {
        content: descriptionResource.description,
    };
}
